import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from '../button';
import ProductCarousel from '../Products/product-carrousel';
import * as action from '../../redux/actions';

class Promotions extends Component {
   constructor(props) {
      super(props);
      this.state = {
         user: this.props.user,
      };
   }

   componentDidMount() {
      this.fetchHomeProducts();
   }

   async fetchHomeProducts() {
      this.props.dispatch(action.getHomeProducts());
   }

   render() {
      const { homeProducts, refProp } = this.props;

      const categoryOneProducts = homeProducts && homeProducts.categoryOne;
      const categoryTwoProducts = homeProducts && homeProducts.categoryTwo;
      const categoryThreeProducts = homeProducts && homeProducts.categoryThree;

      return (
         <div className="flex promotions">
            <div className="justify-center">
               <div className="container">
                  <div className="column">
                     <div className="white-space-32"></div>
                     <div className="promotion-title color-red align-center">
                        <div className="justify-start align-center">
                           <i className="fas fa-medkit"></i>
                           <h2
                              className="color-secondary quicksand"
                              ref={refProp}
                           >
                              Conoce nuestros productos
                           </h2>
                        </div>
                     </div>
                     <div className="white-space-56"></div>
                     <ProductCarousel products={categoryOneProducts} />
                     <div className="white-space-56"></div>
                     <ProductCarousel products={categoryTwoProducts} />
                     <div className="white-space-56"></div>
                     <ProductCarousel products={categoryThreeProducts} />
                     <div className="white-space-64"></div>
                     <div className="btn-catalog justify-center align-center">
                        <Link to="/catalogo">
                           <Button theme="soft-red">Ver catálogo</Button>
                        </Link>
                     </div>
                     <div className="popup justify-center hidden" id="popup">
                        <div className="container align-center justify-center">
                           <i className="color-white fas fa-shopping-cart"></i>
                           <p className="color-white">
                              &nbsp;Añadido al Carrito
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

function mapStateToProps(state) {
   return {
      user: state.user,
      homeProducts: state.homeProducts,
   };
}

export default connect(mapStateToProps)(Promotions);



// WEBPACK FOOTER //
// ./src/components/Promotions/promotions.js